module.exports = __webpack_public_path__ + "img/juggernaut.b185f8d8.jpg";